var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section mb-0" },
    [
      _vm.title
        ? _c("div", { staticClass: "section-title" }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("date-picker", {
        attrs: {
          value: _vm.day,
          disabledDates: _vm.disabledDates,
          "full-month-name": true,
          maximumView: "day",
          language: _vm.ptBR,
          format: "dd MMMM yyyy",
          inline: _vm.inline,
          "calendar-class": "calendar-position",
          "input-class": "calendar-input",
          placeholder: "selecione um dia"
        },
        on: { selected: _vm.daySelected }
      }),
      _vm._v(" "),
      _vm.day && !_vm.canPayViaBoleto
        ? _c("small", [
            _vm._v(
              "\n    O dia selecionado permite pagamentos apenas pelo\n    "
            ),
            _c("b", [_vm._v("cartão de crédito")]),
            _vm._v("\n    , escolha à partir do dia\n    "),
            _c("b", [_vm._v(_vm._s(_vm.firstDayToPayViaBoleto()))]),
            _vm._v(" caso queira efetuar o pagamento por\n    "),
            _c("b", [_vm._v("boleto")]),
            _vm._v(".\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.day
        ? _c("holiday-warning", {
            staticStyle: { "max-width": "450px", "text-align": "center" },
            attrs: { day: _vm.day }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5153a452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5153a452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/DatePicker.vue
// module id = null
// module chunks = 